<template>
  <div class="radio">
    <el-radio-group
      v-model="value"
      @change="radioChange"
    >
      <el-radio
        v-for="option in question.optionList"
        :key="option.key"
        :label="option.key"
      >
        {{ option.label }}
      </el-radio>
    </el-radio-group>

  </div>
</template>

<script>
import mixins from "./mixins";

export default {
  name: "radioKey",
  mixins: [mixins],
  data() {
    return {
      value: "",
    };
  },
  watch: {
    question: {
      handler(newVal) {
        if (!newVal.answer) {
          this.value = undefined;
        } else if (newVal.answer.key !== this.value) {
          this.value = newVal.answer.key;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    radioChange(value) {
      const { optionList } = this.question;
      optionList.some((option) => {
        if (option.key === value) {
          this.change(option);
          return true;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>